import React from "react";
import { Trans } from "@lingui/macro";
import {
  connectInfiniteHits,
  connectStateResults
} from "react-instantsearch-dom";
import "./InfiniteSearchResults.scss";
import { Button } from "@silversea-ssc/ui-components-react";

const InfiniteHits = ({
  hits,
  hasMore,
  refineNext,
  hitComponent: HitComponent,
  hitComponentProps = {},
  allSearchResults
}) => {
  let hiddenResults = 0;
  if (allSearchResults) {
    const { hitsPerPage, nbHits, page } = allSearchResults;
    hiddenResults = Math.max(nbHits - hitsPerPage * (page + 1), 0);
  }

  return (
    <React.Fragment>
      <ul className="ssc-infinite-search-results">
        {hits.map((hit) => (
          <li key={hit.objectID} className="ssc-infinite-search-results__item">
            <HitComponent hit={hit} {...hitComponentProps} />
          </li>
        ))}
      </ul>
      <div
        className={`ssc-infinite-search-results__load-more${
          hasMore ? "" : "--disabled"
        }`}
      >
        <Button
          renderAs="button"
          onClick={refineNext}
          iconName="plus"
          variant="secondary"
          data-content-piece="more_results"
        >
          <Trans>More Results</Trans> ({hiddenResults})
        </Button>
      </div>
    </React.Fragment>
  );
};

const InfiniteSearchResults = connectInfiniteHits(
  connectStateResults(InfiniteHits)
);
export default InfiniteSearchResults;
